export const SHOW_LOGIN_MODAL = 'SHOW_LOGIN_MODAL';
export function showLoginModal(canClose: boolean = true,emailAlreadyExists: boolean = false) {
  return {
    type: SHOW_LOGIN_MODAL,
    canClose: canClose,
    emailAlreadyExists:emailAlreadyExists,
  };
}

export const CHANGE_STATE_OF_CLOSE = 'CHANGE_STATE_OF_CLOSE';
export function changeStateOfClose(stateOfClose: boolean){
  return {
    type:CHANGE_STATE_OF_CLOSE,
    stateOfClose:stateOfClose
  };
} 
export const SHOW_CONFIRMATION_MODAL = 'SHOW_CONFIRMATION_MODAL';
export function showConfirmationModal() {
  return {
    type: SHOW_CONFIRMATION_MODAL,
  };
}

export const SHOW_REGISTER_MODAL = 'SHOW_REGISTER_MODAL';
export function showRegisterModal(canClose: boolean = true) {
  console.log(canClose+":can");
  
  return {
    type: SHOW_REGISTER_MODAL,
    canClose: canClose
  };
}

export const SHOW_CONTINUE_REGISTER_MODAL = 'SHOW_CONTINUE_REGISTER_MODAL';
export function showContinueRegisterModal(userData: any) {
  return {
    type: SHOW_CONTINUE_REGISTER_MODAL,
    userData: userData,
  };
}

export const SHOW_ADDRESS_MODAL = 'SHOW_ADDRESS_MODAL';
export function showAddressModal(guestState:boolean,canClose: boolean = true){
  return {
    type: SHOW_ADDRESS_MODAL,
    isGuest: guestState,
    canClose: canClose,
  };
}


export const TOGGLE_CONTINUE_SHOPPING_MODAL = 'TOGGLE_CONTINUE_SHOPPING_MODAL';
export function toggleContinueShoppingModal(state: Boolean) {
  return {
    type: TOGGLE_CONTINUE_SHOPPING_MODAL,
    isShow: state,
  };
}

export const TOGGLE_GUEST_CHECK_MODAL = 'TOGGLE_GUEST_CHECK_MODAL';
export function toggleGuestCheckModal(state: boolean) {
  return {
    type: TOGGLE_GUEST_CHECK_MODAL,
    isShow:state,
  };
}

export const SHOW_Payment_MODAL = 'SHOW_Payment_MODAL';
export function showPaymentModal(userData: any) {
  return {
    type: SHOW_Payment_MODAL,
    userData: userData
  };
}



export const HIDE_AUTH_MODALS = 'HIDE_AUTH_MODALS';
export function hideAuthModals() {
  return {
    type: HIDE_AUTH_MODALS,
  };
}



